// Dashboard.js constants
export const NO_WIDGETS_CONFIGURED = "No widgets configured";
export const ADD_WIDGETS_TO_START =
  "Add widgets to start building your dashboard";

// RolesDropdown.js constants
export const SELECT_ROLES_PLACEHOLDER = "Select roles...";

// WidgetHeader.js constants
export const EDIT_PROPERTIES = "Edit Properties";
export const DELETE = "Delete";

// WidgetSelectionSheet.js constants
export const EDIT_DASHBOARD = "Edit Dashboard";
export const SELECT_WIDGETS_TO_ADD = "Select widgets to add";
export const SEARCH_METRICS = "Search metrics";
export const SEARCH_WIDGETS_PLACEHOLDER = "Search widgets...";
export const CLOSE_METRICS_PANEL = "Close metrics panel";
// SAVE is defined in DashboardContainer.js section

// EditWidgetConfigPanel.js constants
export const EDIT_WIDGET_CONFIG = "Edit Widget Configuration";
export const TRIGGERED_VISIBILITY_SETTINGS =
  "Triggered Visibility Settings (Coming Soon)";
export const DAILY_TIME_PERIOD = "Daily Time Period:";
export const START_TIME = "Start Time:";
export const END_TIME = "End Time:";
export const SELECT_START_TIME = "Select start time";
export const SELECT_END_TIME = "Select end time";
export const ALERT_SETTINGS = "Alert Settings (Coming Soon)";
export const DISABLED = "Disabled";
export const ALERT_CONDITION = "Alert Condition:";
export const THRESHOLD_VALUE = "Threshold Value:";
export const THRESHOLD_VALUE_PLACEHOLDER = "Threshold value";
export const ALERT_TRIGGER_MESSAGE =
  "Alert will trigger when widget value exceeds";
export const CANCEL = "Cancel";
export const SAVE_CHANGES = "Save Changes";

// ChartWidget.js constants
export const FIFTEEN_MIN = "15 min";
export const THIRTY_MIN = "30 min";
export const CUMULATIVE = "Cumulative";
export const ANNOTATION_LINE_DATA_POINTS = 1000;
export const STAT_SUM = "SUM";
export const STAT_CUMULATIVE_SUM = "CUMULATIVE_SUM";

// BaseWidget.js constants
export const ERROR_LOADING_WIDGET_DATA = "Error loading widget data";

// DashboardContainer.js constants
export const MY_SCC = "MY SCC";
export const CUSTOMIZABLE_DASHBOARD_TOOLTIP =
  "Customizable dashboard for metrics and widgets";
export const LAST_UPDATED = "Last updated: ";
export const SAVE = "Save";
export const EDIT = "Edit";
export const ADD_WIDGETS_TOOLTIP = "Add Widgets";
export const ADD = "Add";
export const HIGH_PRIORITY_DASHBOARD = "High Priority Dashboard";
export const HIGH_IMPORTANCE_METRICS_TOOLTIP =
  "Dashboard containing High Importance Metrics";
export const SCOPE = "Scope";
export const DASHBOARD = "Dashboard";
export const USER_CUSTOMIZABLE_WIDGETS_TOOLTIP =
  "Dashboard containing User Customizable Widgets";

export const ROLE_OPTIONS = [
  { value: "inbound", label: "Inbound" },
  { value: "sortation", label: "Sortation" },
  { value: "outbound", label: "Outbound" },
  { value: "otr", label: "OTR" },
  { value: "rts", label: "RTS" },
  { value: "assets", label: "Assets (CPO, Scanners)" },
];

// Toast notification levels
export const TOAST_NOTIFICATION_LEVELS = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
};

// Toast notification actions
export const TOAST_NOTIFICATION_ACTIONS = {
  SHOW_SINGLE_TOAST: "SHOW_SINGLE_TOAST",
  SHOW_MULTIPLE_TOASTS: "SHOW_MULTIPLE_TOASTS",
  REMOVE_TOAST: "REMOVE_TOAST",
};

// Toast messages
export const TOAST_MESSAGES = {
  DASHBOARD_SAVED: "Great! Your Dashboard is now Saved!",
  WIDGET_ADDED: "Widgets have been added!",
  WIDGET_DELETED: "Widget has been deleted!",
  ROLE_SELECTION_REQUIRED: "You need at least one role selected",
};

// Configuration group types
export const CONFIG_GROUP_TYPES = {
  DEFAULT: "DEFAULT",
  STATION_CODE: "STATION_CODE",
  USER_ALIAS: "USER_ALIAS",
  PRIORITY: "PRIORITY",
};



// WEBPACK FOOTER //
// ./src/components/mySCC/constants/Constants.js